<template>
  <div class="o_l p_t">
    <TopHead title="我的订单"></TopHead>
    <div class="ol_tab d_f ali_c j_s">
      <div :class="acTab == 0 ? 'ac' : ''" @click="changeType(0)">全部</div>
      <!--<div :class="acTab == 2 ? 'ac' : ''" @click="changeType(2)">已支付</div>-->
      <div :class="acTab == 3 ? 'ac' : ''" @click="changeType(3)">待付款</div>
      <div :class="acTab == 6 ? 'ac' : ''" @click="changeType(6)">已完成</div>
      <div :class="acTab == 2 ? 'ac' : ''" @click="changeType(2)">已关闭</div>
    </div>
    <div class="d_f ali_c j_c no_data" v-if="!list.length">
      <div class="t_a">
        <img src="../assets/img/ol_no_icon.png" alt="">
        <div>暂无订单</div>
        <div class="no_data_btn" @click="$router.push('/Mall')">前往研学商城</div>
      </div>
    </div>
    <van-pull-refresh v-model="loading" @refresh="onRefresh" v-else>
      <van-list
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="list_out">
          <div class="items" v-for="(item,index) in list" :key="index" @click="$router.push('/OrderDetail?orderId='+item.orderId)">
            <div class="d_f j_s top_tag">
              <div class="tag" :style="{backgroundColor : item.bgColor}">{{item.commodityTypeName}}</div>
              <div class="red_t d_f ali_c status_t">
                <template v-if="item.showStatus == 1 || item.showStatus == 3">
                  <img src="../assets/img/ol_time.png" alt="">
                  <van-count-down :time="item.cuttime" />
                </template>
                <span  v-if="item.showStatus == 2" class="grey_t">已关闭</span>
                <span  v-if="item.showStatus == 6" class="blue_t">已完成</span>
              </div>
            </div>
            <div class="lo_c d_f">
              <van-image fit="cover" :src="item.commodityCoverOne"/>
              <!--<img :src="item.commodityCoverOne" alt="">-->
              <div class="flex_1 over_h">
                <div class="loc_t">{{item.commodityName}}</div>
                <div class="loc_sub"><span>{{item.startTime.split(' ')[0]}}</span> <span class="p_r cut_line">—</span> <span>{{item.endTime.split(' ')[0]}}</span><span v-if="item.duration"> | 共{{item.duration}}</span>
                  <span v-for="(itm,idx) in item.tagList" :key="idx" v-if="itm">{{' | '+itm}}</span>
                </div>
                <div class="loc_sub" v-if="item.orderType == 0">报名人员：{{item.sellNum}}人</div>
                <div class="loc_sub" v-else>购买数量：{{item.sellNum}}个</div>
              </div>
            </div>
            <div class="d_f ali_c btns">
              <div class="price flex_1">
                <span>实付金额</span>
                <span class="red_t">￥<span>{{item.sellPrice ? item.sellPrice/100 : 0}}</span></span>
              </div>
              <div class="t_r">
                <div class="d_i btn" v-if="item.showStatus == 1 || item.showStatus == 3" @click.stop="cancelOrder(item)">取消订单</div>
                <div class="d_i btn blue" v-if="item.showStatus == 1 || item.showStatus == 3">待支付</div>
                <div class="d_i btn"  v-if="item.showStatus == 2" @click.stop="deleteOrder(item)">删除订单</div>
                <div class="d_i btn"  v-if="item.showStatus == 6" @click="$router.push('/OrderDetail?orderId='+item.orderId)">查看详情</div>
                <!--<div class="d_i btn blue">申请退款</div>-->
                <!--<div class="d_i btn blue">撤销</div>-->
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
  export default {
    name: "OrderList",
    data() {
      return {
        acTab:1,
        refreshing:false,
        loading:true,
        finished:false,
        list:[],
        params:{
          pageIndex:1,
          pageSize:10,
          orderStatus:0,
        },
        info:[1,2,3,4],
        time:3000,
      }
    },
    //订单状态 0全部、2已取消、3待支付、6已完成
    created(){
      this.acTab = Number(this.$route.query.tab) || 0;
      this.params.orderStatus = Number(this.$route.query.tab) || 0;
      this.listOrder();
    },
    methods: {
      // 删除订单
      deleteOrder(row){
        this.$dialog.confirm({
          message: '确定删除订单？',
          confirmButtonText:'确定',
          confirmButtonColor:'#24BDDD',
          cancelButtonText:'我再想想',
        })
          .then(() => {
            this.$api.delOrder({orderId:row.orderId}).then(res => {
              this.$toast('操作成功');
              setTimeout(() => {
                this.list = [];
                this.listOrder();
              },1000)
            })
          })
          .catch(() => {
            // on cancel
          });

      },
      //取消订单
      cancelOrder(row){
        let _t = this;
        _t.$dialog.confirm({
          message: '是否取消该订单',
          confirmButtonColor:'#24BDDD',
        }).then(() => {
          _t.$api.cancelOrder({orderId:row.orderId}).then(res => {
            _t.$toast('操作成功');
            setTimeout(function () {
              _t.list = [];
              _t.listOrder();
            },500)
          })
        })
      },
      //订单单列表
      listOrder(){
        this.loading = true;
        this.$api.listOrder(this.params).then(res => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          this.list.map(item => {
            let now = new Date().getTime();
            let order = new Date(this.$renderTime(item.createTime)).getTime();
            if((order + 15 * 60 * 1000)>now){
              item.cuttime = (order + 15 * 60 * 1000) - now;
            }else{
              item.cuttime = 0;
            }
          })
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      changeType(num){
        this.acTab = num;
        this.params.orderStatus = num;
        this.onRefresh()
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listOrder();
      },
      onLoad(){
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listOrder();
      },
    }
  }
</script>

<style scoped lang="scss">
  .cut_line{
    vertical-align: top;
  }
  .no_data{
    .no_data_btn{
      margin-top: 14px;
      width: 137px;
      height: 46px;
      line-height: 43px;
      font-size: 13px;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
      text-align: center;
      background: url("../assets/img/ol_no_btn.png") no-repeat;
      background-size: 100% 100%;
    }
    img{
      width: 108px;
      margin-bottom: 19px;
    }
    font-size: 13px;
    font-weight: 400;
    color: #3E3E3E;
    height: calc(100vh - 280px);
  }
  .o_l{
    .list_out{

      .price{
        .red_t{
          margin-left: 12px;
          span{
            font-size: 16px;
          }
        }
        font-size: 12px;
        font-weight: 500;
        color: #606060;
      }
      .btns{
        padding: 10px 15px 13px 5px;
      }
      .btn{
        &.blue{
          color: white;
          border-color: #24BDDD;
        }
        margin-left: 12px;
        width: 74px;
        height: 27px;
        border: 1px solid #CBCBCB;
        border-radius: 13px;
        line-height: 27px;
        text-align: center;
      }
      .lo_c{
        .loc_sub{
          font-size: 10px;
          font-weight: 500;
          color: #909090;
          margin-bottom: 8px;
        }
        .loc_t{
          width: 100%;
          font-size: 12px;
          font-weight: bold;
          color: #000000;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 10px;
        }
        img,.van-image{
          width: 100px;
          height: 90px;
          margin-right: 7px;
        }
        padding: 11px 9px 0 9px;
      }
      .items{
        .top_tag{
          .status_t{
            position: relative;
            top: 6px;
          }
          .red_t{
            img{
              width: 13px;
              height: 13px;
              margin-right: 5px;
            }
            .van-count-down{
              color: #ED5B5B;
              line-height: 1;
            }
            color: #ED5B5B;
            font-size: 14px;
          }
          font-size: 13px;
          font-weight: bold;
          padding-right: 19px;
        }
        .tag{
          font-size: 13px;
          font-weight: bold;
          color: #FFFFFF;
          width: 70px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          border-radius: 5px 0px 5px 0px;
        }
        margin-bottom: 10px;
        background: #FFFFFF;
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        position: relative;
      }
      padding: 0 13px;
    }
    .ol_tab{
      .ac{
        border-radius: 3px;
        border-bottom: 5px solid #24BDDD;
        font-size: 15px;
        font-weight: bold;
        color: #3E3E3E;
        line-height: 24px;
      }
      font-size: 13px;
      font-weight: 500;
      color: #BEBEBE;
      line-height: 24px;
      padding: 16px 27px 30px;
    }
    background-color: #f5f5f5;
  }

</style>
